// cn.js
module.exports = {
  router_title_001: "Home page",
  router_title_002: "Mail",
  router_title_003: "Write a email",
  router_title_004: "Sending completed",
  router_title_005: "New page reading",
  router_title_006: "Extra large accessories",
  router_title_007: "Account information",
  router_title_008: "Account security",
  router_title_009: "Remote login log",
  router_title_010: "Trust login location",
  router_title_011: "Change password",
  router_title_012: "Other mailbox accounts (POP)",
  router_title_013: "Add other email accounts",
  router_title_014: "Folder management",
  router_title_015: "Blacklist",
  router_title_016: "Forward and reply",
  router_title_017: "Automatic forwarding setting log",
  router_title_018: "Message classification rules",
  router_title_019: "Create a new rule",
  router_title_020: "Setting log",
  router_title_021: "General settings",
  router_title_022: "Client Settings",
  router_title_023: "Personal signature",
  router_title_024: "Create a new signature",
  router_title_025: "Anti garbage setting",
  router_title_026: "Address book",
  router_title_027: "Bind phone",
  router_title_028: "Unbind phone",
  wm_lang_9c710b:"File size is",
  wm_lang_html_95b351:"Edit",
  wm_lang_html_e0f673:"This function has been disabled. Please contact the administrator",
  wm_lang_f90387:"Separate multiple keywords with \",\"",
  wm_lang_html_f3a485:"New folder",
  wm_lang_html_0b543c:"The administrator has disabled automatic forwarding to foreign domains",
  wm_lang_html_9c51b4:"renewal",
  wm_lang_669656:"Rule name is not less than ",
  wm_lang_html_e8e492:"Add classified automatic forwarding function, and support automatic forwarding according to filter conditions；",
  wm_lang_fec2b4:"Client authorization code",
  wm_lang_html_24c669:"Total number of emails",
  wm_lang_html_3d448d:"Three-level navigation",
  wm_lang_html_0d8f65:"Simple red",
  wm_lang_html_6b0d50:"Mobile phone:",
  wm_lang_e680e9:"Calculation completed",
  wm_lang_58c224:"Up to",
  wm_lang_e2ee4e:"Every 2 days",
  wm_lang_53d9ef:"Encoding",
  wm_lang_dbf6d0:"Please enter email",
  wm_lang_76ea0d:"Bcc",
  wm_lang_html_fb5bf1:"To",
  wm_lang_html_eab129:"Personal information",
  wm_lang_b09b04:"Add phone at most",
  wm_lang_html_4de530:"Language and timezone",
  wm_lang_cc97eb:"The destination folder belongs to the source folder",
  wm_lang_html_7a3680:"Mail Development Department",
  wm_lang_5d44d9:"A folder with the same name exists",
  wm_lang_e747e8:"'s get again",
  wm_lang_b720a6:"Under review",
  wm_lang_953b40:"without attachment",
  wm_lang_html_9439fa:"After opening the client authorization code, the original mailbox password will not be able to login on the client, and can only login with the new client authorization code.",
  wm_lang_html_2df6a3:"From: ",
  wm_lang_2f234b:"Draft saved successfully",
  wm_lang_html_38cf16:"Confirm",
  wm_lang_425169:"Message content",
  wm_lang_html_d43e13:"Group contacts",
  wm_lang_html_043897:"SMS notification",
  wm_lang_199536:"The mailbox password cannot be empty",
  wm_lang_ef0b42:"Module expansion",
  wm_lang_html_d3298c:"Personal contacts",
  wm_lang_html_f10ed4:"Create a new rule",
  wm_lang_html_a34e49:"No email available.",
  wm_lang_html_5ee6c3:"Drag and add",
  wm_lang_html_55405e:"Export",
  wm_lang_c566ca:"Server",
  wm_lang_html_5abe91:"Unstarred",
  wm_lang_d87502:"More than characters to be filled in the moderator's mailbox",
  wm_lang_b7612b:"null",
  wm_lang_html_fd5757:"Add a phishing link reminder, and a security prompt will pop up when you click the link in the message body;",
  wm_lang_19cd24:"Cloud Vision",
  wm_lang_0c686f:"The input length does not exceed",
  wm_lang_html_973732:"Forwarded",
  wm_lang_331b7f:"not include",
  wm_lang_ff1c7d:"Search in email header",
  wm_lang_6a3db1:"emails",
  wm_lang_c9a507:"Update prompt",
  wm_lang_58f966:"Size",
  wm_lang_html_5b0520:"Apply",
  wm_lang_1e6021:"Open in new tab",
  wm_lang_4848e1:"Spam notification",
  wm_lang_7a615e:"Employee ID",
  wm_lang_e8ed1b:"Edit other email accounts",
  wm_lang_b33403:"You can only import at a time",
  wm_lang_8c3f97:"Good afternoon!",
  wm_lang_html_1dea3a:"and",
  wm_lang_379b24:"Not more than ",
  wm_lang_9aab18:"Edit group",
  wm_lang_html_e5f71f:"Search",
  wm_lang_abeee9:"Anti garbage level",
  wm_lang_f12e4a:"if",
  wm_lang_html_da671a:"WeChat:",
  wm_lang_html_cb0ed5:"High",
  wm_lang_188e4b:"move to specified folder",
  wm_lang_320dcb:"Password strength",
  wm_lang_html_88f1fc:"This sender",
  wm_lang_d716f1:"to",
  wm_lang_html_5b6010:" And some other applications ",
  wm_lang_93d159:"Sent faxes",
  wm_lang_html_f1d5f5:"Mail List",
  wm_lang_a11cc7:"Please enter content",
  wm_lang_html_5120e6:"More than",
  wm_lang_html_c247ad:"Unread ",
  wm_lang_00237d:"Bcc：",
  wm_lang_20a495:"Copy succeeded",
  wm_lang_html_a7a6eb:"emails",
  wm_lang_d1a00e:"Attach name:",
  wm_lang_html_58037b:": ",
  wm_lang_c14d45:"Set page chip navigation",
  wm_lang_html_4d7ea6:"Save Draft",
  wm_lang_8ea35c:"Modify signature",
  wm_lang_2299ac:"Please enter the correct fax",
  wm_lang_cae255:"Upload time",
  wm_lang_84bef0:"Modify Rule",
  wm_lang_517f89:"Duplicate fax",
  wm_lang_html_189c20:"No contact is selected, click a contact information here",
  wm_lang_html_7cf1f5:"Show",
  wm_lang_html_ee8ecb:"Priority",
  wm_lang_e366cc:"Settings",
  wm_lang_html_c3ba16:"Archived",
  wm_lang_465afe:"",
  wm_lang_html_0ec9ea:"More",
  wm_lang_29d09a:"Jinshajiang Road, Putuo District, Shanghai",
  wm_lang_2c825a:"Select time",
  wm_lang_html_5ef69f:"Icons",
  wm_lang_1ca99a:"Product Announcement",
  wm_lang_html_8becc4:"Anti garbage setting",
  wm_lang_abb501:"Golden time",
  wm_lang_html_a71852:" Or ",
  wm_lang_html_a2247c:"Download All",
  wm_lang_a2b5f6:"Operator mailbox",
  wm_lang_8b6aed:"Preview",
  wm_lang_4c50ee:"Avatar",
  wm_lang_a53c6f:"Delete this rule?",
  wm_lang_html_0dee1e:"Audit result：",
  wm_lang_html_d9cc43:"Large attachment",
  wm_lang_96d2b7:"Delete permanently",
  wm_lang_html_cecc29:"Compose",
  wm_lang_f4578a:"Changed password successfully, please sign in ",
  wm_lang_dc9dae:"Invalid address or domain, please try again!",
  wm_lang_829abe:"Grouping",
  wm_lang_2b45e2:"Do you want to continue",
  wm_lang_6f4450:"Daily sharing",
  wm_lang_873178:"Click to close the tab",
  wm_lang_e5a33f:"The mail maximum and minimum values are not filled correctly (the minimum value should be less than or equal to the maximum value)",
  wm_lang_78f395:"Dropdown",
  wm_lang_html_411fee:"Web page production engineer",
  wm_lang_1ec4aa:"Less than or equal to",
  wm_lang_html_db1c89:"Home",
  wm_lang_2e28bb:"The receiving display name",
  wm_lang_html_ba7cb4:"Agency mail",
  wm_lang_a820f8:"Set as read",
  wm_lang_e39ffe:"Please enter the password",
  wm_lang_html_1d4403:"Super large attachments are automatically saved from the date of uploading",
  wm_lang_html_1535fc:"Send",
  wm_lang_df23a5:"Subject：",
  wm_lang_html_a06d40:"Open",
  wm_lang_930882:"",
  wm_lang_html_db06c7:"Test",
  wm_lang_html_b2352a:"Save to Sent",
  wm_lang_2ad202:"Send an automatic reply to only contacts in your Contacts list",
  wm_lang_html_3be934:"Read",
  wm_lang_fe30da:"Forwarding address existed! ",
  wm_lang_html_ff05d1:"Size (Asc)",
  wm_lang_html_e77c07:"Account security level:",
  wm_lang_html_1b1d05:"Send to",
  wm_lang_3a580c:"Reply all",
  wm_lang_html_055692:"Add contact",
  wm_lang_1e1459:"Department",
  wm_lang_3c3479:"Option 1",
  wm_lang_html_ec8d26:"Mailbox capacity",
  wm_lang_14b860:"Select at least one execution action",
  wm_lang_html_21e106:"Forward",
  wm_lang_html_543b04:"Selected ",
  wm_lang_html_7fc88a:"Change password",
  wm_lang_html_a86903:"More",
  wm_lang_b0b69e:"Please enter the correct fax number",
  wm_lang_html_fcec0a:"Company website:",
  wm_lang_9970ad:"Subject:",
  wm_lang_html_2f78b7:"Forward as Attachment",
  wm_lang_1bb474:"The new password cannot be the same as the original password",
  wm_lang_fd2bf0:"Valid only in the following time periods",
  wm_lang_3d3057:"Automatic reception",
  wm_lang_9bd442:"Cloud Classroom",
  wm_lang_d1d904:"Execution action",
  wm_lang_cf10dc:"Bit",
  wm_lang_63e0ca:"Receipt required",
  wm_lang_23b8db:"Rule name is ok",
  wm_lang_a67a18:"Message signatures",
  wm_lang_60d045:"Name",
  wm_lang_cb0804:"Default Bcc address",
  wm_lang_0d5523:"Every 6 days",
  wm_lang_html_c39922:"Logout",
  wm_lang_html_3b47d7:" File, and no more than ",
  wm_lang_5ea696:"Include original Email when reply",
  wm_lang_1501d5:"subject",
  wm_lang_6ed179:"Rule name cannot be empty",
  wm_lang_html_11ccee:"Etc.",
  wm_lang_html_47595b:"Version",
  wm_lang_fb5158:"Please enter the correct legal mailbox",
  wm_lang_72d55e:"Enter new password",
  wm_lang_html_fa8b0f:"Audit time limit：",
  wm_lang_html_ac1e1c:"To：",
  wm_lang_19eb5b:"Original field",
  wm_lang_43ef05:"Between",
  wm_lang_html_5aefca:"Layout",
  wm_lang_31fd4b:"Spam deletion time",
  wm_lang_b15d91:"Close",
  wm_lang_710ad0:"Stopped",
  wm_lang_80c18f:"Search email",
  wm_lang_812d1b:"Save client sent mail",
  wm_lang_cb6d41:"You will not receive messages from blacklist addresses.",
  wm_lang_9c19a4:"Please enter the original password",
  wm_lang_html_413db9:"Matches, please enter more information to narrow the range",
  wm_lang_html_bbdfe1:"Chen Xu",
  wm_lang_html_ecac25:"Subject (Desc)",
  wm_lang_622b43:"Family",
  wm_lang_c33c30:"Business Style",
  wm_lang_ad9c40:"Please fill in the contents",
  wm_lang_092ba7:"Adv. search",
  wm_lang_html_eb3c99:"Jing",
  wm_lang_a0db8e:"Fields other than Mail ,Phone and Fax can only have unique correspondence",
  wm_lang_html_5d36f1:"Work information",
  wm_lang_html_01cd93:"Delete the forwarded email",
  wm_lang_3a17b7:"Minutes",
  wm_lang_fd2515:"After automatic reply is checked, the reply content cannot be blank",
  wm_lang_d47c7f:"Leng",
  wm_lang_183abe:"Contacts",
  wm_lang_80ef9d:"The size of uploaded avatar image cannot exceed",
  wm_lang_html_6785d8:"Complete the agency",
  wm_lang_html_8d9a07:"Import",
  wm_lang_f41cf0:"Please enter the correct mailbox or domain name",
  wm_lang_3b1083:"Successfully saved",
  wm_lang_html_6afaf4:"Do the following",
  wm_lang_4ebcc8:"Domain announcement mail",
  wm_lang_9fd1b7:"Radio",
  wm_lang_c054fb:"Update record",
  wm_lang_cd649f:"Time limit:",
  wm_lang_ca2153:"If automatic forwarding is checked, the content of automatic forwarding cannot be blank",
  wm_lang_3b239d:"No subject",
  wm_lang_4249f2:"Option 3",
  wm_lang_f13597:"Corresponding field",
  wm_lang_d3637f:"Send a letter",
  wm_lang_html_c57120:"Question",
  wm_lang_html_bb4546:"Optimize now",
  wm_lang_87ba17:" hours",
  wm_lang_html_b8ef0f:"Selected",
  wm_lang_html_46042d:"Large attachment",
  wm_lang_html_5f10ee:"Brown",
  wm_lang_html_0807a3:"Quiet Blue",
  wm_lang_3cebfa:"Good morning!",
  wm_lang_html_2d66a1:"Only upload ",
  wm_lang_html_456b82:"Birthday:",
  wm_lang_69be67:"Modified successfully",
  wm_lang_bff744:"Report spam",
  wm_lang_062ebd:"Reading details page",
  wm_lang_c9ef57:"You can set automated reply message when you are on vacation.",
  wm_lang_html_df23a5:"Subject: ",
  wm_lang_b2f801:"Are you sure you want to close",
  wm_lang_1efeae:"Low",
  wm_lang_html_812024:"Audit message",
  wm_lang_1b3bf0:"Default font for letter writing",
  wm_lang_922a77:"Automated vacation reply",
  wm_lang_7a311d:"Reply: [upgrade announcement] Changxin support",
  wm_lang_html_bffb1c:"Personal signatures",
  wm_lang_185839:"Layout",
  wm_lang_9b3884:"Please fill in the maximum value",
  wm_lang_html_773926:"Not less than ",
  wm_lang_html_939d53:"Submit",
  wm_lang_html_96d2b7:"Delete permanently",
  wm_lang_html_de8610:"Secondary title",
  wm_lang_html_8c18cb:"This message has been approved: because the reviewer has not made a decision within the approval time limit, this message has been delivered normally",
  wm_lang_html_ef801d:"Receive",
  wm_lang_66c3e5:"Green",
  comm_lang_0001:"Days of mail",
  wm_lang_html_738bc9:"Are you sure you want to delete the selected contact?",
  wm_lang_html_607e7a:"Check",
  wm_lang_7d41a2:"Total block:",
  wm_lang_2005d7:"For the security of your account, please change the password",
  wm_lang_html_615db5:"Zhang San",
  wm_lang_faaadc:"No.",
  wm_lang_318305:"New editing page is opened, the previous editing email has been saved in Drafts.",
  wm_lang_html_3be506:"Receiving settings",
  wm_lang_html_38294f:"Layout and skin",
  wm_lang_html_76b8e6:"Invalid format. See example: 1980-09-01.",
  comm_lang_0006:"Search",
  comm_lang_0007:"From include",
  comm_lang_0008:"To include",
  comm_lang_0009:"Subject include",
  comm_lang_0002:"Total ",
  comm_lang_0003:" email",
  comm_lang_0004:" emails.",
  comm_lang_0005:"Searching result",
  wm_lang_9f22bc:"Select font",
  wm_lang_html_c7bc5c:"Add Bcc",
  comm_lang_0010:"The attachment name contains",
  wm_lang_d32b45:"Please fill in your signature",
  wm_lang_html_2f4aad:"Delete",
  comm_lang_0011:"Time from",
  wm_lang_9e4d59:"Mailbox password",
  comm_lang_0012:"to",
  wm_lang_html_8e16eb:"Filters",
  wm_lang_html_afcb3b:"Home address:",
  wm_lang_cb0ed5:"High",
  wm_lang_html_2d7a2f:"Yes",
  wm_lang_15d410:" Characters",
  wm_lang_html_c45357:"System notice",
  wm_lang_457406:"Cancel",
  wm_lang_2de0d4:"Hour",
  wm_lang_5e579b:"Please enter the correct value",
  wm_lang_html_882106:"Classification Rule Setting Log",
  wm_lang_92448a:"Mobile number",
  wm_lang_html_9989a0:"Label",
  wm_lang_html_e41447:"Print",
  wm_lang_html_9ef98a:"Sorry, this file does not support preview",
  comm_lang_0017:"No starred email. You can add stars to the important emails for convenient access.",
  comm_lang_0018:"Not found",
  comm_lang_0019:"emails",
  wm_lang_625fb2:"Cancel",
  comm_lang_0013:"Of",
  comm_lang_0014:"Page",
  wm_lang_be6f79:"Default signature",
  comm_lang_0015:"No messages",
  comm_lang_0016:"No email available.",
  comm_lang_0020:"No email found. Please reset search criteria.",
  wm_lang_06e84a:"Continue",
  wm_lang_2b6bc0:"Operating",
  comm_lang_0021:"Where",
  comm_lang_0022:"Unread ",
  comm_lang_0023:"Set all as read",
  wm_lang_22b433:"Draft",
  wm_lang_html_f26ef9:"Download",
  wm_lang_ea8b1d:"Unable to create",
  wm_lang_6fc450:"Do not display images in spam, click them manually and display them.",
  wm_lang_c4c3f3:"Save emails on server",
  wm_lang_d7ec2d:"name",
  wm_lang_html_b15d91:"Close",
  wm_lang_d28df0:"Search by name, pinyin and initials",
  wm_lang_7f72e8:"Online Service",
  wm_lang_35242c:"Medium",
  comm_lang_0028:"1. It only supports the withdrawal of mail sent to this mail system, and does not support the withdrawal of mail sent to other mail systems",
  wm_lang_1f4c10:"Folder",
  comm_lang_0029:"2. It only supports the recall of messages in webmail, and does not support the recall of messages received locally by mail clients",
  wm_lang_3ffa1d:"include",
  comm_lang_0024:"Clean all spam emails",
  comm_lang_0025:"Message encryption",
  wm_lang_e9e805:" emails.",
  comm_lang_0026:"withdraw the mail",
  wm_lang_html_f952f5:"Sync to cloud schedule",
  comm_lang_0027:"Are you sure you want to recall the message? If the recall is successful, the other party will only see the subject of the message and be prompted that it has been recalled.",
  comm_lang_0031:"4. Only messages sent within 7 days can be recalled",
  wm_lang_html_7d0177:"Prompt: When the message header sent by the other party contains",
  comm_lang_0032:"The withdrawal failed, mail more than 7 days or have been to delete",
  comm_lang_0033:"Withdrawn in",
  wm_lang_bc4364:"Unlimited",
  comm_lang_0034:"complete withdrawal",
  comm_lang_0030:"3. You will be notified of the withdrawal result by system mail",
  wm_lang_9c3c31:"The group to add to cannot be empty",
  wm_lang_3b3190:"Additional comments",
  wm_lang_60eec8:"Operation and maintenance",
  wm_lang_b652de:"Position",
  wm_lang_e11f7c:"The left value should be smaller than the right",
  comm_lang_0039:"Message recall failed",
  wm_lang_2432b5:"Remark",
  wm_lang_b58c75:"Add",
  comm_lang_0035:"withdrawal failed",
  comm_lang_0036:"Successful withdrawal",
  comm_lang_0037:"The other party is not the mailbox of this mail system and cannot be recalled",
  comm_lang_0038:"Recall failed. The message may have been deleted",
  wm_lang_86ed3d:"Move to",
  comm_lang_0042:"Partial withdrawal",
  comm_lang_0043:"The sender has withdrawn the message",
  wm_lang_d6cc4b:"Step 4, start uploading",
  comm_lang_0044:"This message has been recalled by the sender",
  comm_lang_0045:"Sending time",
  wm_lang_html_ac8ccc:"Preview on Mail List",
  wm_lang_html_74c0d8:"Language",
  wm_lang_html_0611d8:")",
  wm_lang_2456c8:"Please improve the information",
  comm_lang_0040:"Withdrawal of state",
  wm_lang_7a2e8b:"Not spam",
  comm_lang_0041:"Have all been withdrawn",
  wm_lang_cef67a:"Japanese",
  wm_lang_html_317a66:" include ",
  wm_lang_a81052:"Password",
  wm_lang_33130f:"Operate successfully",
  wm_lang_8347a9:"Modify",
  wm_lang_html_6bac4d:"Import contacts",
  wm_lang_437839:"Message subject length is limited to",
  wm_lang_html_be5fbb:"Save",
  wm_lang_43b510:"Expiring in ",
  wm_lang_4076f9:"Letter page",
  wm_lang_html_fb8f3d:"Please select the location where the new file is stored:",
  wm_lang_cda4d5:"Choose from contacts",
  wm_lang_38e3ff:"Share received",
  wm_lang_f15261:"Clip",
  wm_lang_e13556:"include",
  wm_lang_69e308:"with attachment",
  wm_lang_732796:"Delete completely",
  wm_lang_html_ba8713:"Trust",
  wm_lang_ec84ea:"Company website",
  comm_lang_0046:"Year",
  wm_lang_8e97c5:"Sending time",
  comm_lang_0047:"Month",
  wm_lang_aef8cb:"中文繁体",
  comm_lang_0048:"Day",
  wm_lang_f35fae:"Fax can be added at most",
  comm_lang_0049:"hour",
  comm_lang_0053:"Set password",
  wm_lang_78b124:"Edit other mailbox accounts",
  wm_lang_d17143:"Forward header",
  wm_lang_html_2a214e:"Reply all with attachment",
  comm_lang_0054:"Confirm password",
  comm_lang_0055:"View password",
  comm_lang_0056:"Hide password",
  comm_lang_0050:"minute",
  comm_lang_0051:"Scheduled time is out",
  wm_lang_41e17a:"Adjustment Notification",
  comm_lang_0052:"After the message is encrypted, the recipient needs to decrypt to view the message content",
  wm_lang_html_2f8d6f:"Yesterday",
  wm_lang_html_a552fc:"Mailbox user login",
  wm_lang_html_2ef722:"Reject",
  wm_lang_html_3c8045:" Please select this item to save to the server after the client sends a message.",
  wm_lang_html_4bea88:"Replied",
  wm_lang_html_31c7ca:"Add to Contacts automatically",
  wm_lang_0c0335:"To do time",
  wm_lang_de0f82:"Keep a copy of forwarded email in your Inbox",
  wm_lang_01d7aa:"Of",
  wm_lang_html_230505:"Withdrawal",
  wm_lang_58ccec:"Moving",
  wm_lang_html_49f15f:"Nested list:",
  wm_lang_html_e4a827:"Starred ",
  wm_lang_38cf16:"Confirm",
  wm_lang_html_ca7b67:"Reedit",
  comm_lang_0057:"Cancel password",
  comm_lang_0058:"Hello,",
  wm_lang_60ae02:"Attachment:",
  comm_lang_0059:"This is an encrypted message. You need to decrypt it before you can view the message content. You can ask the sender for the password in other ways.",
  wm_lang_6fc9ce:"The auto-forward mailbox is filled incorrectly",
  comm_lang_0064:"You can add the common addresses to ",
  comm_lang_0065:"Trusted Login Place",
  comm_lang_0066:"The system will automatically send a remote login reminder when the mailbox account is logged on in a different location to view",
  comm_lang_0067:"Trusted Login Place",
  comm_lang_0060:"Please enter password",
  comm_lang_0061:"Message decryption failed, please re-enter the password",
  comm_lang_0062:"The message has been decrypted. The following is the decrypted message content:",
  comm_lang_0063:"Remote login reminder",
  wm_lang_html_866bc3:"Step 1: Select the file to upload ",
  wm_lang_71b068:"SimSun",
  wm_lang_html_c360e9:"Sort",
  wm_lang_5719f5:"Receipt cancellation",
  wm_lang_a652de:"The string entered is too long",
  wm_lang_39c764:"Port number",
  wm_lang_f013ea:"Loading",
  wm_lang_html_4404d5:"Account security",
  wm_lang_ee3f55:"Country",
  comm_lang_0068:"Due to the limited accuracy of IP location, the domestic location is only accurate to  city",
  wm_lang_f8de3d:"Deleting",
  comm_lang_0069:"Country",
  wm_lang_a9e825:"Mail picture display settings",
  wm_lang_d3298c:"Personal contacts",
  comm_lang_0075:"Operating",
  comm_lang_0076:"Smart Add",
  comm_lang_0077:"Manually added",
  wm_lang_html_961cac:"",
  comm_lang_0078:"Place already exists",
  comm_lang_0071:"City",
  wm_lang_html_52228f:"Expand",
  wm_lang_html_1efeae:"Low",
  comm_lang_0072:"This login location:",
  wm_lang_7e951d:"Operation time",
  comm_lang_0073:"Trusted locations",
  comm_lang_0074:"Type",
  wm_lang_44a0b8:"Select font size",
  wm_lang_a7d3be:"Bottom bar container",
  wm_lang_aa8b9d:"Home address",
  wm_lang_2f4aad:"Delete",
  comm_lang_0070:"Province",
  wm_lang_3bb47b:"Edit succeeded",
  wm_lang_b1baab:"Do not display all the pictures in the mail, click manually and display them.",
  wm_lang_html_7eacb4:"real name",
  wm_lang_0f43f5:"Password cannot be less than",
  wm_lang_d43e13:"Group contacts",
  wm_lang_html_a42d13:"Zhang San's mail name",
  wm_lang_html_694fc5:"Refresh",
  wm_lang_0875ef:"￥",
  wm_lang_f7c30e:"Add large attachment",
  comm_lang_0079:"Remote login log",
  wm_lang_32c65d:"Title",
  wm_lang_719156:"Original sending time：",
  wm_lang_html_0a25da:"Support import ",
  comm_lang_0086:"Operator",
  wm_lang_47631c:"Please enter a text name",
  comm_lang_0087:"Operation time",
  comm_lang_0088:"Operation IP",
  wm_lang_91e9e8:"Regular audit",
  comm_lang_0089:"Operation content",
  wm_lang_28cf54:"Default copy address",
  comm_lang_0082:"Login IP",
  comm_lang_0083:"Reference Location",
  wm_lang_439d6f:"Your mailbox password has expired, please change the password for your account security",
  comm_lang_0084:"Login Method",
  comm_lang_0085:"Setting up logs",
  wm_lang_ce917f:"Custom name cannot be empty",
  comm_lang_0080:"Remote login logs in the last 30 days",
  comm_lang_0081:"Login Time",
  wm_lang_981cbe:" to ",
  wm_lang_html_400521:"Keep a copy of forwarded email in your Inbox",
  wm_lang_a5bfd7:"Successfully added",
  wm_lang_html_deb009:"Download",
  wm_lang_1d468b:"End date",
  wm_lang_7a427c:"Quality Management Department",
  wm_lang_html_22b433:"Draft",
  wm_lang_9989a0:"Label",
  wm_lang_1c8ac2:"Client authorization code function? After successful opening, the original mailbox password will not be able to log in to the client, but can only log in with the new authorization code.",
  wm_lang_html_8b6aed:"Preview",
  wm_lang_html_457406:"Cancel",
  wm_lang_bffb1c:"Personal signatures",
  wm_lang_02aaf1:"Regular script",
  comm_lang_0097:"Keep a copy of forwarded email in your Inbox",
  wm_lang_2e42cc:"Remaining retention period",
  comm_lang_0098:"You can close the recall page and we will send the results to your mailbox",
  wm_lang_html_b50566:"、",
  comm_lang_0099:"Security",
  comm_lang_0093:"Execution action",
  comm_lang_0094:"Automatic forwarding setting log",
  comm_lang_0095:"Forwarding address",
  wm_lang_238ae0:"Time remaining:",
  comm_lang_0096:"Operator mailbox",
  comm_lang_0090:"Rule Name",
  comm_lang_0091:"Rule state",
  wm_lang_8b9c9b:"Failed to read file",
  comm_lang_0092:"Trigger condition",
  wm_lang_30f7dd:"Connect",
  wm_lang_html_922a77:"Automated vacation reply",
  wm_lang_e3d664:"Please enter the correct extension number",
  wm_lang_46323b:"Do you want to send a read receipt?",
  wm_lang_dac715:"Super large attachment uploaded successfully",
  wm_lang_html_f12e4a:"if",
  wm_lang_html_bbdb15:"Add to email",
  wm_lang_0807a3:"Quiet Blue",
  wm_lang_html_bdc07d:" The agreement suggests closing this item",
  wm_lang_fbd05a:"Please select a time",
  wm_lang_html_e0a113:"Back",
  wm_lang_be5fbb:"Save",
  wm_lang_8e16eb:"Filters",
  wm_lang_0f9b40:"Partitioning",
  wm_lang_html_126fc3:"If you want to use ",
  wm_lang_cdd051:"Please fill in the maximum value correctly",
  wm_lang_193a8c:"Telephone number",
  wm_lang_html_9e5ffa:"Basic information",
  wm_lang_5cc232:"Deleted",
  wm_lang_0611d8:")",
  wm_lang_html_06ee96:"settings",
  wm_lang_6a5aa0:"Groupped contacts successfully",
  wm_lang_62a7e4:"The new password does not meet the rules",
  wm_lang_html_f54c5e:"In this network security attack and defense drill,",
  wm_lang_html_b58c75:"Add",
  wm_lang_2ef722:"Reject",
  wm_lang_html_e4ef4a:"Managing folders",
  wm_lang_827d98:"Store to",
  wm_lang_ea57da:"Right Tab",
  wm_lang_html_6297bc:"Unselect",
  wm_lang_6231a2:"No reply",
  wm_lang_98c30b:"Step 2, get",
  wm_lang_6d37b4:"Searching result: Personal contacts",
  wm_lang_f26ef9:"Download",
  wm_lang_702513:"Sending",
  wm_lang_html_374237:"（",
  wm_lang_html_d3b98f:"，",
  wm_lang_html_3593a5:"Dept: ",
  wm_lang_549308:"It's late at night, have an early rest",
  wm_lang_html_713272:"Attachment",
  wm_lang_da0291:"Not include",
  wm_lang_708c9d:"Please select",
  wm_lang_html_a6c60b:"Incorrect format, example",
  wm_lang_8441b3:"Unspecified",
  wm_lang_73347e:"Step 1, the calculation is completed, and the",
  wm_lang_d41a62:"Delay succeeded",
  wm_lang_html_00237d:"Bcc：",
  wm_lang_7c6a2c:"Search by name, email and mobile...",
  wm_lang_html_4cbc13:"Folder:",
  wm_lang_html_98f89e:"This action will delete the contact from all groups.",
  wm_lang_b1c5ea:"Do you want to save this message to a draft",
  wm_lang_html_b59b00:"Used",
  wm_lang_html_528e20:": Select the trigger condition of the rule",
  wm_lang_html_7bbc73:"Subject",
  wm_lang_e5b49e:"Real",
  wm_lang_html_e39b19:"From new to old",
  wm_lang_html_14e6d8:"Time:",
  wm_lang_7b6234:"Please fill in the correct email address",
  wm_lang_41716f:"Company",
  wm_lang_html_ae4fd4:"Clean all spam emails",
  wm_lang_2c35d9:"Blacklist address",
  wm_lang_6eb535:"Company Dynamics",
  wm_lang_html_e9e805:" emails.",
  wm_lang_694fc5:"Refresh",
  wm_lang_html_7fe4a6:"Other account",
  wm_lang_9088d8:"Forwarding by attachment can only be checked",
  wm_lang_html_35242c:"Medium",
  wm_lang_html_92e3a8:"Help",
  wm_lang_html_da4495:"Mailbox:",
  wm_lang_html_c82a9d:"Receive",
  wm_lang_html_21efd8:"No data yet",
  wm_lang_html_cb8dc2:"Subject (Asc)",
  wm_lang_5c7c95:"Failed to delete account",
  wm_lang_html_69e308:"with attachment",
  wm_lang_69e94f:"Click here to quickly reply to everyone",
  wm_lang_html_857cee:"then",
  wm_lang_a7699b:"Upload succeeded",
  wm_lang_b44c0f:"Start date",
  wm_lang_html_183abe:"Contacts",
  wm_lang_html_3a580c:"Reply all",
  wm_lang_e4a827:"Starred ",
  wm_lang_ca7b67:"Reedit",
  wm_lang_d0f6ef:"Calculated current block:",
  wm_lang_html_2c808b:"Click Upload",
  wm_lang_042be4:"Only removed from this group.",
  wm_lang_html_980b27:".",
  wm_lang_html_a00f23:"Messages selected",
  wm_lang_a98473:"Folder name",
  wm_lang_html_8f4f08:"Notes Contacts Name",
  wm_lang_html_2064fc:"Do not display",
  wm_lang_html_b79a4e:"Return",
  wm_lang_4bea88:"Replied",
  wm_lang_html_63e0ca:"Receipt required",
  wm_lang_14fe7d:"My name",
  wm_lang_50a9be:"Company Zip Code",
  wm_lang_html_f1d4ff:"Custom",
  wm_lang_html_cf10dc:"Bit",
  wm_lang_66f0da:"The attachment upload has not been completed, please wait",
  wm_lang_3fdaea:"Successfully added",
  wm_lang_098730:"And cannot contain",
  wm_lang_a46aa1:"Add another email account",
  wm_lang_html_6ffab1:"Other options",
  wm_lang_html_40ad89:"Company Zip Code:",
  wm_lang_f23656:"Create at most ",
  wm_lang_0007d1:"Delete succeeded",
  wm_lang_bce314:"Put in junk e-mail folder (recommended)",
  wm_lang_198d41:"You can't add your own mailbox",
  wm_lang_html_0f87e0:"Update prompt",
  wm_lang_4f21b0:"Fax",
  wm_lang_html_3149de:"Unselect",
  wm_lang_html_53cab4:"Account information",
  wm_lang_d0a548:"When the above conditions are met: then",
  wm_lang_eb0ef8:"The maximum number of phones is",
  wm_lang_0182f1:"Cool Black",
  wm_lang_b2352a:"Save to Sent",
  wm_lang_2cff3b:"Imitating the Song Dynasty",
  wm_lang_5a93d3:"Phone",
  wm_lang_d7c0a1:"Enterprise mailbox",
  wm_lang_168dfa:"Official script",
  wm_lang_7f9402:"To：",
  wm_lang_html_bee912:"Query",
  wm_lang_6a23f1:"Searching result: Team contacts",
  wm_lang_html_ae2e1f:"The administrator has disabled automatic forwarding",
  wm_lang_html_f03d42:"Include members:",
  wm_lang_html_d16180:"Nickname:",
  wm_lang_dec892:"：",
  wm_lang_html_2bf9a9:"Send separately",
  wm_lang_db1c89:"Home",
  wm_lang_d6aac9:"Cannot move",
  wm_lang_e06494:"Company address",
  wm_lang_18c634:"Default",
  wm_lang_19ac67:"Low",
  wm_lang_html_7a2e8b:"Not spam",
  wm_lang_01468d:"Port number cannot be empty",
  wm_lang_html_1edff0:"Reply",
  wm_lang_html_dfe170:"Indefinitely",
  wm_lang_html_f25118:"Your email has been sent",
  wm_lang_21e106:"Forward",
  wm_lang_html_ecda36:"Sorry, the file is too large. We recommend you check it after downloading",
  wm_lang_b5771a:"Display by default after login",
  wm_lang_561caa:"Mailbox format error",
  wm_lang_5ce1e1:"Save message as download",
  wm_lang_461d8d:"Latest announcement",
  wm_lang_3bc5e6:"Mailbox",
  wm_lang_54e5de:"Failed to upload",
  wm_lang_ce219a:"The result of the reviewer who first made the decision shall be the final decision",
  wm_lang_9365f3:"Message subject header Message subject header Message subject header Message subject header",
  wm_lang_html_27dfde:"Employee No.:",
//自定义多语言字段://自定义多语言字段
  wm_lang_3755ef:"Verifying account",
  wm_lang_html_1501d5:"subject",
  wm_lang_8572ea:"Please fill in the minimum value",
  wm_lang_html_f6d477:"Company:",
  wm_lang_html_092ba7:"Adv. search",
  wm_lang_html_2dc4ac:"Beijing 263 Enterprise Communication Co., Ltd.",
  wm_lang_738e4a:"The announcement you viewed no longer exists",
  wm_lang_314f60:"Saved successfully, required",
  wm_lang_7093b9:"Empty canceled",
  wm_lang_cd0ed2:"Moved to Inbox",
  wm_lang_f7a9dd:"The content of this message has been modified",
  wm_lang_html_7a311d:"Reply: [upgrade announcement] Changxin support",
  wm_lang_67bc37:"network disk",
  wm_lang_641b90:"After automatic forwarding is checked, the forwarding content cannot be blank",
  wm_lang_7650a1:"Spaces are not supported",
  wm_lang_c34281:"Cancelled deletion",
  wm_lang_20601f:"Telephone repeat",
  wm_lang_002a67:"Recently used date",
  wm_lang_a12b8a:"My Files",
  wm_lang_html_26f9bf:"Submenu",
  wm_lang_cfbf6f:"WeChat",
  wm_lang_html_d7405e:"List name:",
  wm_lang_b43f83:"Node click callback",
  wm_lang_61f562:"This operation will permanently delete the file",
  wm_lang_html_7b4a28:"Mailbox service",
  wm_lang_html_aa4d94:"Cancel",
  wm_lang_3c18db:"Account detection icon",
  wm_lang_e2cd2e:"Client authorization code function? After successful closing, all client authorization codes will be deleted, and only the original mailbox password can be used to log in to the client.",
  wm_lang_html_383698:"Recent login log:",
  wm_lang_html_35c8ad:"Automatic forwarding",
  wm_lang_371528:"City",
  wm_lang_8d90d2:"Select oversized accessories",
  wm_lang_html_5cc232:"Deleted",
  wm_lang_html_3b3495:"Fix the problem of verifying the validity of the recipient's address on the letter page;",
  wm_lang_47b0da:"The mail will be delivered normally only after it is approved by all reviewers; if one of them makes a rejection decision, the mail will be deleted",
  wm_lang_html_66c3e5:"Green",
  wm_lang_html_c6b4d7:"Phone:",
  wm_lang_0c1fec:"Seconds",
  wm_lang_18d771:"Please enter the correct mobile number",
  wm_lang_243e1d:"Authorization code usage cannot be empty",
  wm_lang_9034c8:"Preview signature",
  wm_lang_ba6025:"Please separate multiple email addresses with English commas",
  wm_lang_a1d1e5:"Greater than or equal to",
  wm_lang_html_c228dd:"Messages,",
  wm_lang_html_cdd451:"Have all been withdrawn",
  wm_lang_23eb0e:"Nickname",
  wm_lang_196ef3:"Home zip code",
  wm_lang_html_0eab0c:"Send an email on behalf: please pay attention!",
  wm_lang_612c43:"Add other email accounts",
  wm_lang_html_b3b1f7:"Reject",
  wm_lang_html_508db5:"Charge at login",
  wm_lang_html_465afe:"",
  wm_lang_html_61a68d:"without attachment",
  wm_lang_dade72:"Set Page Form Component",
  wm_lang_html_6a3db1:"emails",
  wm_lang_html_74e5c0:"Schedule send",
  wm_lang_9ef16d:"Display of toolbar button",
  wm_lang_671c0d:"Japanese",
  wm_lang_5c6881:"null",
  wm_lang_html_7854b5:"Enable",
  wm_lang_html_918b52:"No contact selected, click one to display here",
  wm_lang_html_69a924:"Zero error in security policy",
  wm_lang_html_f6ccd0:"size",
  wm_lang_bc2f65:"Korean",
  wm_lang_870802:"Rule Name",
  wm_lang_html_0be5a1:"Skin",
  wm_lang_1e86ec:"Account deleted successfully",
  wm_lang_e3127c:"Format",
  wm_lang_5893fa:"Email accounts",
  wm_lang_c2460e:"The maximum number of faxes is",
  wm_lang_5ee1ff:"The mailbox name cannot be empty",
  wm_lang_html_a8b0c2:"All ",
  wm_lang_12da81:"Letter completion page",
  wm_lang_html_cbfcf6:"Set personal signature",
  wm_lang_20be4e:"Loading, please wait",
  wm_lang_8483ed:"Date of birth",
  wm_lang_e6f070:"Audit time",
  wm_lang_html_645dbc:"Preview",
  wm_lang_html_625fb2:"Cancel",
  wm_lang_html_918362:"Display settings",
  wm_lang_65f627:"Upload the new files",
  wm_lang_html_f48072:"Safety tips:",
  wm_lang_bf3c5b:"Korean",
  wm_lang_html_ff1c7d:"Search in email header",
  wm_lang_html_c4746d:"No email selected, click one to display here.",
  wm_lang_153fa6:"Select",
  wm_lang_952f2d:"The maximum number of files uploaded has reached",
  wm_lang_f3a485:"New folder",
  wm_lang_8f40db:"Assignment",
  wm_lang_fcbb1f:"Files, please delete the current file and upload again",
  wm_lang_html_2cc0ca:"Fix mail parsing problems such as reading page style and garbled code;",
  wm_lang_3d14d1:"Province",
  wm_lang_670d63:"Confirm new password",
  wm_lang_html_2cb96f:"Client Settings",
  wm_lang_64a156:"You have not added any document!",
  wm_lang_6b0bc6:"Operator",
  wm_lang_5f10ee:"Brown",
  wm_lang_554626:"Step 3, assignment",
  wm_lang_html_c8a933:"Modify now",
  wm_lang_543586:"Please enter the correct phone number",
  wm_lang_df4b35:"Currently there are rules",
  wm_lang_html_919466:"Include department:",
  wm_lang_html_d88651:"The remaining space",
  wm_lang_21cf5e:"The maximum number of mailboxes is",
  wm_lang_html_f75896:"Group:",
  wm_lang_html_a72631:"Must contain any uppercase letters, lowercase letters, numbers or symbols ",
  wm_lang_0eeee5:"Set filtering rules to classify messages.",
  wm_lang_211cfb:"Server cannot be empty",
  wm_lang_html_8ad629:"Read",
  wm_lang_05e8d4:"Request read receipt",
  wm_lang_b90ee1:"Common Upload Component",
  wm_lang_html_854db2:"Set all as read",
  wm_lang_6105e1:"Anti waste treatment",
  wm_lang_html_740499:"Size (Desc)",
  wm_lang_html_86ed3d:"Move to",
  wm_lang_c45357:"System notice",
  wm_lang_html_44a2c7:" contacts",
  wm_lang_html_288f0c:"Empty",
  wm_lang_f070aa:"Hello",
  wm_lang_716c3d:"Street",
  wm_lang_7deb96:"Recipient email address",
  wm_lang_24e8a8:"The system will automatically clean more than in the \"trash can\"",
  wm_lang_4a0838:"Create a new signature",
  wm_lang_ac9f45:"Reply succeeded",
  wm_lang_e0b014:"Classification filtering rules can be added at most",
  wm_lang_0c9eaa:"The value of is:",
  wm_lang_html_67596c:"No messages",
  wm_lang_html_ec0bce:"Related",
  wm_lang_html_cda4d5:"Choose from contacts",
  wm_lang_html_e13556:"include",
  wm_lang_f5854e:"The star mark has been canceled",
  wm_lang_0c498b:"Please contact the administrator",
  wm_lang_cecc29:"Compose",
  wm_lang_html_93d159:"Sent faxes",
  wm_lang_05dfc3:"Receipt succeeded",
  wm_lang_aa2fb1:"Please select a date",
  wm_lang_0b2f8e:"中文简体",
  wm_lang_f9fb6a:"English",
  wm_lang_ff29b9:"Email has been sent",
  wm_lang_html_053355:"After that, an emergency coordination team was established",
  wm_lang_b1415d:"Please select addresses to delete!",
  wm_lang_html_78ad95:"Additional comments：",
  wm_lang_d3950d:"Pink Memories",
  wm_lang_8beefb:"Audit results",
  wm_lang_0ad062:"Step 4, packet loss and waiting",
  wm_lang_html_196bf0:"You haven't added a contact",
  wm_lang_e0b004:"Bold",
  wm_lang_f10ed4:"Create a new rule",
  wm_lang_7c2f8e:"Fax number",
  wm_lang_348913:"Skin",
  wm_lang_html_3950e5:"From old to new",
  wm_lang_html_95bde0:"Add timed automatic reply function, and support automatic reply according to time cycle setting;",
  wm_lang_8e22f1:"Left navigation",
  wm_lang_fd4cfa:"Audit type：",
  wm_lang_ca5f4c:"Low level (mail other than blacklist will not be judged as spam)",
  wm_lang_html_f5de9e:"Attach",
  wm_lang_html_aab57a:"Invert Selection",
  wm_lang_82da89:"Reviewer",
  wm_lang_html_d87502:"More than characters to be filled in the moderator's mailbox",
  wm_lang_572fc4:"The system folder cannot be deleted",
  wm_lang_html_89da89:": Execute action",
  wm_lang_a4c993:"Are you sure you want to delete the group",
  wm_lang_b87f22:"Audit failed (",
  wm_lang_230505:"Withdrawal",
  wm_lang_333e4b:"The destination folder is the same as the source folder",
  wm_lang_22c795:"Authorization code can be added at most ",
  wm_lang_46042d:"Large attachment",
  wm_lang_5c0086:"Custom name cannot exceed",
  wm_lang_5f6025:"Effective after the page.",
  wm_lang_5f4fd0:"Top bar container",
  wm_lang_7354e6:"Recently used",
  wm_lang_html_5a3009:"Reminder period",
  wm_lang_html_f83e6b:"Set default sender name",
  wm_lang_a85cce:"Rule state",
  wm_lang_html_ca5b2d:"Forward and reply",
  wm_lang_html_8347a9:"Modify",
  wm_lang_2cf58f:"Option 4",
  wm_lang_6732fd:"All emails",
  wm_lang_22b234:"In the folder",
  wm_lang_html_ab20cc:"and",
  wm_lang_2685dc:"Emptying succeeded",
  wm_lang_2a8140:"Delete selected addresses from blacklist?",
  wm_lang_0efb20:"Please select at least one",
  wm_lang_e61f2c:"Agree",
  wm_lang_312df5:"Are you sure you want to delete this client authorization code? After successful deletion, this authorization code will not be able to log in on the client.",
  wm_lang_6aea59:"Import to group",
  wm_lang_html_83aa19:"Maximum automatic forwarding address",
  wm_lang_40ff1a:"Bit, not greater than ",
  wm_lang_8dd066:"Binding mobile",
  wm_lang_html_ab9ed8:"No matching results found",
  wm_lang_html_021161:"Gender:",
  wm_lang_65939c:"Trigger condition",
  wm_lang_fbd2b1:"Total ",
  wm_lang_cc1bac:" Bar",
  wm_lang_html_992cd2:"Navy",
  wm_lang_f3b7af:"Password purpose",
  wm_lang_70a47f:"The recipients of this email can not download the attachment after the email being deleted. Delete anyway?",
  wm_lang_442c6a:"Group",
  wm_lang_html_894a10:"Unread",
  wm_lang_defd7b:"Sender：",
  wm_lang_html_52b365:"Step",
  wm_lang_html_d4095c:"General settings",
  wm_lang_86988e:"Duplicate mailbox",
  wm_lang_6367e7:"Order",
  wm_lang_9ad8d3:"Authcode",
  wm_lang_html_392898:"",
  wm_lang_html_44c32e:"Group name",
  wm_lang_html_026601:" Or authenticated user name",
  wm_lang_html_d8b930:"Message by",
  wm_lang_24969a:"Cc",
  wm_lang_a41baf:"Please fill in the signature name",
  wm_lang_b2fbc1:"Fill in at least one information",
  wm_lang_html_c33c30:"Business Style",
  wm_lang_html_751ce6:"Remarks:",
  wm_lang_19a1ee:"Draft saving failed",
  wm_lang_6f67c4:"The folder name cannot contain any of the following characters:",
  wm_lang_html_92636e:"Skip",
  wm_lang_6b0fd2:"Mail list",
  wm_lang_html_bf74e9:"Custom Sender Name",
  wm_lang_html_930882:"",
  wm_lang_787b56:"Gender",
  wm_lang_7854b5:"Enable",
  wm_lang_46ad5e:"Too large accessory space is insufficient",
  wm_lang_html_a675fc:"This password is randomly generated by the system. Please copy it and keep it properly. If you forget it, please delete it and rebuild it.",
  wm_lang_html_f7b320:"No.",
  wm_lang_html_88c952:"From",
  wm_lang_96900d:"Select",
  wm_lang_5cd3b6:"Advanced (Whitelists, same domain, and contacts in the address book are not considered spam)",
  wm_lang_b7abee:"Option 2",
  wm_lang_b6d16a:"Import successfully",
  wm_lang_25c9ea:"Auditor：",
  wm_lang_e75969:"Inbox",
  wm_lang_html_ca746b:"Text",
  wm_lang_c2b9f4:"Root foler",
  wm_lang_8abc56:"Action bar",
  wm_lang_html_bb93ed:"Standby",
  wm_lang_696f5a:"Create date",
  wm_lang_0c9e6a:"Length in",
  wm_lang_html_ed8f43:"At the same time, all contacts in this group will be completely deleted from the personal address book.",
  wm_lang_html_93d79c:"Contact",
  wm_lang_html_54480f:"As one of the defense units, the enterprise mailbox is receiving the invitation of action from the Three Gorges Group",
  wm_lang_html_8f5c40:"Home zip code:",
  wm_lang_f30bfb:"Please use , to separate different mail addresses",
  wm_lang_html_dec892:"：",
  wm_lang_1edff0:"Reply",
  wm_lang_5f4112:"Return",
  wm_lang_html_614fc6:"Example:",
  wm_lang_html_390209:"Cannot contain user name or domain name",
  wm_lang_html_6b8677:"Add to Contacts manually",
  wm_lang_330363:"Succeed",
  wm_lang_0d64f2:"Intermediate (recommended, identify spam according to the system's anti-spam rules and black-and-white list settings)",
  wm_lang_html_4b9c32:"Reset",
  wm_lang_5ac57c:"Text box",
  wm_lang_html_2d23c6:"Audit record：",
  wm_lang_html_12d795:"Earlier update records",
  wm_lang_3683f3:"Display mail pictures",
  wm_lang_973732:"Forwarded",
  wm_lang_c2fe62:"Filter",
  wm_lang_c6cceb:"agenda",
  wm_lang_78623e:"Every day",
  wm_lang_dcc242:"Support creation at most",
  wm_lang_a5ff1b:"Not forwarded",
  wm_lang_html_d4c366:"Testing",
  wm_lang_74225e:"Drop down two",
  wm_lang_306a2a:"The server length cannot exceed",
  wm_lang_971f54:"Microsoft Yahei",
  wm_lang_a6beb9:"Switch",
  wm_lang_6a5f04:"Please enter the correct email address",
  wm_lang_3caa33:"Start using this account",
  wm_lang_html_55c3f6:"Take",
  wm_lang_f9d94b:"The email will be deleted permanently, do you want to continue?",
  wm_lang_21cad5:"Secure login verification",
  wm_lang_html_22f94c:"Total domain announcement messages",
  wm_lang_af3c66:"Add at most mailboxes",
  wm_lang_html_1a63ac:"Example",
  wm_lang_html_6e0780:"Please log in with your real account",
  wm_lang_c00500:"Cc：",
  wm_lang_18b2e0:"Forwarding to outland is not allowed, please contact administrator!",
  wm_lang_1e9b8e:"Please fill in the minimum value correctly",
  wm_lang_html_0c71d6:"Set default font",
  wm_lang_html_4a0838:"Create a new signature",
  wm_lang_237651:"The message is being sent",
  wm_lang_ac1e1c:"To：",
  wm_lang_d69797:"There are duplicate forwarding addresses",
  wm_lang_html_9ab2e7:"As an unusual contact, please check the identity of the other person",
  wm_lang_html_2f293a:"Starred",
  wm_lang_68018f:"Youyuan",
  wm_lang_html_fcbc6a:"Space",
  wm_lang_html_cce9c9:"Last modified password:",
  wm_lang_6e7b20:"Reply sender only",
  wm_lang_70281d:"Please enter the correct phone number",
  wm_lang_5df03b:"Please enter a folder name",
  wm_lang_e10150:"The folder name cannot contain spaces and special characters",
  wm_lang_8a45a9:"Are you sure you want to renew this oversized attachment?",
  wm_lang_8ad629:"Read",
  wm_lang_0bb8f9:"Junk E-mail",
  wm_lang_cd043c:"Enter current password",
  wm_lang_a8b0c2:"All ",
  wm_lang_html_d3950d:"Pink Memories",
  wm_lang_74e5c0:"Schedule send",
  wm_lang_95b351:"Edit",
  wm_lang_919ca6:"Drop down one",
  wm_lang_55481b:"Don't remind me",
  wm_lang_3d99b6:"Addresses are separated by \",\"",
  wm_lang_html_a7a342:"Fixed",
  wm_lang_html_1c02de:"Correspondence mail",
  wm_lang_html_8d0cfb:"Add files",
  wm_lang_f857f6:"Password usage cannot contain spaces and ",
  wm_lang_html_66eeac:"Select all",
  wm_lang_html_897d4f:"Solve the problem of spam identification and misjudgment;",
  wm_lang_html_6b05b5:"Sending email",
  wm_lang_e4a3b5:"Please enter blacklist address",
  wm_lang_f0d640:"The two passwords are inconsistent",
  wm_lang_96ce79:", the file cannot be added",
  wm_lang_html_6219c6:"Mailing list of",
  wm_lang_d9e569:"Account added successfully",
  wm_lang_fddcd7:"Failed to import",
  wm_lang_html_58378f:"Text",
  wm_lang_html_e93381:"Enterprise mailbox helps the Three Gorges",
  wm_lang_html_536d2c:"Delete email",
  wm_lang_d27299:"Send an automatic reply to each sender only once",
  wm_lang_443f46:"Multiple choice",
  wm_lang_35a2b9:"Are you sure you want to open",
  wm_lang_html_552823:"Save as default signature",
  wm_lang_3fea7c:"Status",
  wm_lang_html_e5ff1a:"Please select a file to add: ",
  wm_lang_c3ba16:"Archived",
  wm_lang_html_6b0fd2:"Mail list",
  wm_lang_992cd2:"Navy",
  wm_lang_html_df99b1:"Your email account has certain security risks, please follow the tips below to optimize",
  wm_lang_html_a46aa1:"Add another email account",
  wm_lang_html_4c785f:"Add File",
  wm_lang_html_4a5c68:"Upload to my online disk",
  wm_lang_html_e0745b:"Not starred",
  wm_lang_0d8f65:"Simple red",
  wm_lang_19fcb9:"Date",
  wm_lang_html_442c6a:"Group",
  wm_lang_html_5751bf:"landline:",
  wm_lang_2b9bad:"Distribution group name cannot be empty",
  wm_lang_27bf68:"Your email password is too simple. Please change the password for your account security",
  wm_lang_fb5bf1:"To:",
  wm_lang_9dcd1b:"Are you sure you want to move the selected contacts out of this group?",
  wm_lang_html_2a2080:"File.",
  wm_lang_511fd1:"The Send separately function here distribute mass mail to every recipient separately. Each recipient can only see his own email address as a sole recipient address, instead of seeing all other target recipients. Are you sure you want to continue?",
  wm_lang_html_600565:"Cannot contain three consecutive or identical characters",
  wm_lang_html_249aba:" days ",
  wm_lang_html_40ff1a:"Bit, not greater than",
  wm_lang_7edd32:"Good evening!",
  wm_lang_html_c3eb73:"Managing folders",
  wm_lang_html_abb501:"Golden time",
  wm_lang_html_e75969:"Inbox",
  wm_lang_e6df5b:"Add Description",
  wm_lang_html_cb0e98:"Check all",
  wm_lang_12f1d7:"End",
  wm_lang_4ff1e7:"Date",
  wm_lang_19fee2:"Every 5 days",
  wm_lang_a30c4e:"New group",
  wm_lang_3cec17:"Password length cannot exceed",
  wm_lang_html_727725:"Company address:",
  wm_lang_html_267e95:"New contact",
  wm_lang_9c49ab:"Are you sure not to fill in the subject",
  wm_lang_html_cc4637:"Don't use too simple passwords, such as ",
  wm_lang_2f2786:"Operation content",
  wm_lang_5abe91:"Unstarred",
  wm_lang_d26ecc:"Mailbox name",
  wm_lang_html_bcbfe2:"Blacklist",
  wm_lang_html_90585c:"Set agent",
  wm_lang_html_c2fe62:"Filter",
  wm_lang_650b9f:"Select at least one corresponding field",
  wm_lang_da760a:"Other mailbox accounts (",
  wm_lang_3806fe:"Forwarding address",
  wm_lang_html_918be6:" Combination of species",
  wm_lang_f361ce:"Set as unread",
  wm_lang_1e328f:"Please select the file to upload",
  wm_lang_html_570e7f:" send me an e-mail alert",
  wm_lang_ae4b6b:" Signatures",
  wm_lang_59592b:"Signature name",
  wm_lang_html_0182f1:"Cool Black",
  wm_lang_10a48a:"Please add recipient and sender",
  wm_lang_358fd1:"Move succeeded",
  wm_lang_397654:"The uploaded avatar image can only be",
  wm_lang_4351f4:"Good morning!",
  wm_lang_html_458e42:"This page has been checked",
  wm_lang_2f293a:"Starred",
  wm_lang_249aba:" days ",
  wm_lang_html_e37075:"Advanced Settings",
  wm_lang_html_be2525:"Signature",
  wm_lang_41ec00:"Box",
  wm_lang_html_88866c:"Partially withdrawn",
  wm_lang_html_2d76b9:"Position:",
  wm_lang_b4f3cb:"Collecting ",
  wm_lang_f2e77e:"Every 4 days",
  wm_lang_f0b9f4:"Step 5, upload in pieces",
  wm_lang_html_f515f8:"Retest",
  wm_lang_html_808773:"Sender descending",
  wm_lang_a24ab0:"Please enter the password again",
  wm_lang_html_3d2a2f:"Plugin support speed seconds and resuming of file transfers",
  wm_lang_html_c00500:"Cc：",
  wm_lang_ace6d1:"If auto reply is checked, the auto reply content cannot be blank",
  wm_lang_674b1e:"The receiving account can receive mail from other mailboxes.",
  wm_lang_2bebdd:"Select date",
  wm_lang_html_ecf9b6:"Automatic forwarding setting log",
  wm_lang_cc2644:"Please mark the use of this authorization code to avoid forgetting",
  wm_lang_35c8ad:"Automatic forwarding",
  wm_lang_html_b4cc1c:" Special characters",
  wm_lang_html_b411f8:"Full-text search function is added to support searching messages by message body or attachment name;",
  wm_lang_88c952:"From:",
  wm_lang_0ec9ea:"More",
  wm_lang_e4b8bb:"Total",
  wm_lang_html_dfe48d:",",
  wm_lang_29d8d8:"Personal notes",
  wm_lang_316206:"Set up to do",
  wm_lang_html_b960ee:"Upload to super large attachment",
  wm_lang_894a10:"Unread",
  wm_lang_html_0bb8f9:"Junk E-mail",
  wm_lang_01efad:"Add authcode",
  wm_lang_html_2161fa:"Cannot be the same as the original password",
  wm_lang_2d711b:"Content",
  wm_lang_html_5f4112:"Return",
  wm_lang_html_e366cc:"Settings",
  wm_lang_7173f8:"Reject",
  wm_lang_html_bf498c:"Initial default prompt text",
  wm_lang_295bb7:"Language",
  wm_lang_html_0345b9:"Sender ascending",
  wm_lang_a8424d:"Please re-enter",
  wm_lang_html_e7d4e2:"Generate authorization code",
  wm_lang_361e3d:"Left setting navigation",
  wm_lang_958962:"Edit folder",
  wm_lang_28ee2b:"No permission, please contact the administrator",
  wm_lang_html_79d3ab:"Copy",
  wm_lang_03dcfd:"Every 3 days",
  custom_lang_0001:"Please enter password",
  custom_lang_0002:"The two password entries are inconsistent",
  custom_lang_0003:"Hello, ",
  custom_lang_0004:"This is an encrypted message. You need to decrypt it before you can view the message content. You can ask the sender for the password in other ways",
  custom_lang_0005:"The following address does not exist or is malformed. Please check:",
  custom_lang_0006:"Do you want to delete the following folder?",
  custom_lang_0007:"Operation succeeded. Your verdict is",
  custom_lang_0008:"Display",
  custom_lang_0009:"Do not add again",
  custom_lang_0010:"Mailbox ",
  custom_lang_0011:" already exists!",
  custom_lang_0012:"Only files in csv format can be uploaded, and no more than ",
  custom_lang_0013:"Will",
  custom_lang_0014:"contacts in are exported in CSV format.",
  custom_lang_0015:"The length of distribution group name cannot exceed ",
  custom_lang_0016:" characters",
  custom_lang_0017:"You have not received any domain announcement messages.",
  custom_lang_0018:"More operations",
  custom_lang_0019:"Save as eml file",
  custom_lang_0020:"Manually add common login addresses to ",
  custom_lang_0021:"Trust login location",
  custom_lang_0022:", The system will automatically send a remote login reminder when the mailbox account is logged in to another location for viewing ",
  custom_lang_0023:"Remote login log",
  custom_lang_0024:"Operation failed",
  custom_lang_0025:"Please select a trust location",
  custom_lang_0026:"Please select a place of trust, at least\" province \"",
  custom_lang_0027:"Delete the selected trust location?",
  custom_lang_0028:"Add up to 20 trusted locations",
  custom_lang_0029:"Drag and drop files directly into this area to add them as attachments",
  custom_lang_0030:"matches, please enter more information to narrow the range",
  custom_lang_0031:"Password length cannot be greater than 20 digits",
  custom_lang_0032:"For more results, please check the email withdrawal notice",
  custom_lang_0033:"Sign in",
  custom_lang_0034:"Password error",
  custom_lang_0035:"Send mail regularly",
  custom_lang_0036:"Please select a fixed time for sending messages",
  custom_lang_0037:"The set time has expired",
  custom_lang_0038:"Selected",
  custom_lang_0039:"No contact is selected, click a contact information to display here",
  custom_lang_0040:"Today",
  custom_lang_0041:"Tomorrow",
  custom_lang_0042:"Yesterday",
  custom_lang_0043:"Attachment size exceeds the limit, maximum",
  custom_lang_0044:"The number of recipients exceeds the limit",
  custom_lang_0045:"The file you selected has exceeded the normal attachment",
  custom_lang_0046:"Please upload the maximum size to the oversized attachment.",
  custom_lang_0047:"Validity period",
  custom_lang_0048:"Password cannot contain spaces",
  custom_lang_0049:"Please enter password:",
  custom_lang_0050:"Add ",
  custom_lang_0051:" to the blacklist?",
  custom_lang_0052:"Please select the location to delete",
  custom_lang_0053:"Not used",
  custom_lang_0054:"Default order",
  custom_lang_0055:"Name(Asc)",
  custom_lang_0056:"Name(Desc)",
  custom_lang_0057:"Address(Asc)",
  custom_lang_0058:"Address(Desc)",
  custom_lang_0059:"Please upload pictures smaller than 1M",
  custom_lang_0060:"Delete group",
  custom_lang_0061:"External Contacts",
  custom_lang_0062:"Inbox",
  custom_lang_0063:"Outbox",
  custom_lang_0064:"Deleted",
  custom_lang_0065:"Draft box",
  custom_lang_0066:"Trash Bin",
  custom_lang_0067:"Archived",
  custom_lang_0068:"Backed up",
  custom_lang_0069:"Star Mail",
  custom_lang_0070:"To Do Mail",
  custom_lang_0071:"Internal network",
  custom_lang_0072:"Hello!",
  custom_lang_0073:"Do you want to empty the following folder?",
  custom_lang_0074:"Moved to ",
  custom_lang_0075:"Successfully recalled",
  custom_lang_0076:"Posting or category filtering deletion, cannot be recalled",
  custom_lang_0077:"Recall failed. The message may have been deleted",
  custom_lang_0078:"The email address is not in this mail system and cannot be recalled",
  custom_lang_0079:"Step 2: Select the group to be imported and the field name corresponding to the file.",
  custom_lang_0080:"Delete signature ",
  custom_lang_0081:"Delete ",
  custom_lang_0082:" account",
  custom_lang_0083:"The number of automatic forwarding addresses exceeds the maximum limit ",
  custom_lang_0084:"The quantity cannot exceed ",
  custom_lang_0085:", etc the automatic reply flag, you will no longer automatically reply to the other party.",
  custom_lang_0086:"The time period cannot be empty",
  custom_lang_0087:"Enable automatic forwarding",
  custom_lang_0088:"Turn off automatic forwarding",
  custom_lang_0089:"Modify automatic forwarding",
  custom_lang_0090:"Unknown",
  custom_lang_0091:"Create a new rule",
  custom_lang_0092:"Modify Rules",
  custom_lang_0093:"Delete Rule",
  custom_lang_0094:"Move Up Rule",
  custom_lang_0095:"Move Down Rule",
  custom_lang_0096:"4. Can only be withdrawn",
  custom_lang_0097:"hours",
  custom_lang_0098:"days",
  custom_lang_0099:"mail sent within",
  custom_lang_0100:"Secondary login verification",
  custom_lang_0101:"According to the security settings of this account, SMS verification is required for this login. (If there are special circumstances that cannot be verified, you can contact the company administrator to unbind your phone.)",
  custom_lang_0102:"Phone bound",
  custom_lang_0103:"Obtain verification code",
  custom_lang_0104:"SMS verification code",
  custom_lang_0105:"Please enter the verification code",
  custom_lang_0106:"Login to the same browser without secondary verification",
  custom_lang_0107:"Retrieve again in 60 seconds",
  custom_lang_0108:"The verification code SMS has been sent, please check it carefully.",
  custom_lang_0109:"Verification code input error",
  custom_lang_0110:"The verification code is invalid or has expired",
  custom_lang_0111:"Security Reminder",
  custom_lang_0112:"Bind phone",
  custom_lang_0113:"Reminder method",
  custom_lang_0114:"Email reminder",
  custom_lang_0115:"SMS reminder",
  custom_lang_0116:"Secure login",
  custom_lang_0117:"Secondary login verification",
  custom_lang_0118:"After enabling secondary login verification, when the user logs into the webpage email, in addition to account and password verification, secondary verification is also required",
  custom_lang_0119:"Verification method",
  custom_lang_0120:"Verify every login",
  custom_lang_0121:"Remote login verification",
  custom_lang_0122:"Mobile phone number",
  custom_lang_0123:"SMS verification code",
  custom_lang_0124:"Please enter your phone number",
  custom_lang_0125:"Please enter the verification code",
  custom_lang_0126:"The phone number format is incorrect",
  custom_lang_0127:"Verification code input error",
  custom_lang_0128:"Obtain verification code",
  custom_lang_0129:"Second acquisition",
  custom_lang_0130:"The verification code SMS has been sent, please check it carefully.",
  custom_lang_0131:"If the original phone number cannot be verified, please contact the company administrator to unbind.",
  custom_lang_0132:"Your email account has been linked to your phone",
  custom_lang_0133:"Unbind phone",
  custom_lang_0134:"Binding successful",
  custom_lang_0135:"Unbind successful",
  custom_lang_0136:"Unbind",
};



// WEBPACK FOOTER //
// ./src/vueI18n/en.js